'use client';

import React from 'react';
import { Box, Container, Typography, Chip } from '@mui/material';
import FaqSection from '@/components/ui/faq/FaqSection';
import FooterFaq from '@/components/ui/faq/FooterFaq';
import { useTranslations } from 'next-intl';

export default function FaqContent() {
    const t = useTranslations('FAQ');

    const descriptionLines = ['line_1', 'line_2', 'line_3', 'line_4', 'line_5', 'line_6', 'line_7'];

    const preparationItems = [
        { q: t('faq_1.q_1'), a: { title: t('faq_1.a_1_title'), description: t('faq_1.a_1_description'), note: t('faq_1.a_1_note') } },
        { q: t('faq_1.q_2'), a: { title: t('faq_1.a_2_title'), description: t('faq_1.a_2_description'), note: t('faq_1.a_2_note') } },
        { q: t('faq_1.q_3'), a: { title: t('faq_1.a_3_title'), description: t('faq_1.a_3_description'), note: t('faq_1.a_3_note') } },
        { q: t('faq_1.q_4'), a: { title: t('faq_1.a_4_title'), description: t('faq_1.a_4_description'), note: t('faq_1.a_4_note') } },
        { q: t('faq_1.q_5'), a: { title: t('faq_1.a_5_title'), description: t('faq_1.a_5_description'), note: t('faq_1.a_5_note') } },
        { q: t('faq_1.q_6'), a: { title: t('faq_1.a_6_title'), description: t('faq_1.a_6_description'), note: t('faq_1.a_6_note') } },
        { q: t('faq_1.q_7'), a: { title: t('faq_1.a_7_title'), description: t('faq_1.a_7_description'), note: t('faq_1.a_7_note') } },
        { q: t('faq_1.q_8'), a: { title: t('faq_1.a_8_title'), description: t('faq_1.a_8_description'), note: t('faq_1.a_8_note') } },
    ];

    const serviceItems = [
        { q: t('faq_2.q_1'), a: { title: t('faq_2.a_1_title'), description: t('faq_2.a_1_description'), note: t('faq_2.a_1_note') } },
        { q: t('faq_2.q_2'), a: { title: t('faq_2.a_2_title'), description: t('faq_2.a_2_description'), note: t('faq_2.a_2_note') } },
        { q: t('faq_2.q_3'), a: { title: t('faq_2.a_3_title'), description: t('faq_2.a_3_description'), note: t('faq_2.a_3_note') } },
        { q: t('faq_2.q_4'), a: { title: t('faq_2.a_4_title'), description: t('faq_2.a_4_description'), note: t('faq_2.a_4_note') } },
        { q: t('faq_2.q_5'), a: { title: t('faq_2.a_5_title'), description: t('faq_2.a_5_description'), note: t('faq_2.a_5_note') } },
        { q: t('faq_2.q_6'), a: { title: t('faq_2.a_6_title'), description: t('faq_2.a_6_description'), note: t('faq_2.a_6_note') } },
        { q: t('faq_2.q_7'), a: { title: t('faq_2.a_7_title'), description: t('faq_2.a_7_description'), note: t('faq_2.a_7_note') } },
        { q: t('faq_2.q_8'), a: { title: t('faq_2.a_8_title'), description: t('faq_2.a_8_description'), note: t('faq_2.a_8_note') } },
        { q: t('faq_2.q_9'), a: { title: t('faq_2.a_9_title'), description: t('faq_2.a_9_description'), note: t('faq_2.a_9_note') } },
        { q: t('faq_2.q_10'), a: { title: t('faq_2.a_10_title'), description: t('faq_2.a_10_description'), note: t('faq_2.a_10_note') } },
        { q: t('faq_2.q_11'), a: { title: t('faq_2.a_11_title'), description: t('faq_2.a_11_description'), note: t('faq_2.a_11_note') } },
        { q: t('faq_2.q_12'), a: { title: t('faq_2.a_12_title'), description: t('faq_2.a_12_description'), note: t('faq_2.a_12_note') } },
        { q: t('faq_2.q_13'), a: { title: t('faq_2.a_13_title'), description: t('faq_2.a_13_description'), note: t('faq_2.a_13_note') } },
        { q: t('faq_2.q_14'), a: { title: t('faq_2.a_14_title'), description: t('faq_2.a_14_description'), note: t('faq_2.a_14_note') } },
        { q: t('faq_2.q_15'), a: { title: t('faq_2.a_15_title'), description: t('faq_2.a_15_description'), note: t('faq_2.a_15_note') } },

    ];

    const supportItems = [
        { q: t('faq_3.q_1'), a: { title: t('faq_3.a_1_title'), description: t('faq_3.a_1_description'), note: t('faq_3.a_1_note') } },
        { q: t('faq_3.q_2'), a: { title: t('faq_3.a_2_title'), description: t('faq_3.a_2_description'), note: t('faq_3.a_2_note') } },
        { q: t('faq_3.q_3'), a: { title: t('faq_3.a_3_title'), description: t('faq_3.a_3_description'), note: t('faq_3.a_3_note') } },
        { q: t('faq_3.q_4'), a: { title: t('faq_3.a_4_title'), description: t('faq_3.a_4_description'), note: t('faq_3.a_4_note') } },
        { q: t('faq_3.q_5'), a: { title: t('faq_3.a_5_title'), description: t('faq_3.a_5_description'), note: t('faq_3.a_5_note') } },
        { q: t('faq_3.q_6'), a: { title: t('faq_3.a_6_title'), description: t('faq_3.a_6_description'), note: t('faq_3.a_6_note') } },
        { q: t('faq_3.q_7'), a: { title: t('faq_3.a_7_title'), description: t('faq_3.a_7_description'), note: t('faq_3.a_7_note') } },
    ];

    const feeContract = [
        { q: t('faq_4.q_1'), a: { title: t('faq_4.a_1_title'), description: t('faq_4.a_1_description'), note: t('faq_4.a_1_note') } },
        { q: t('faq_4.q_2'), a: { title: t('faq_4.a_2_title'), description: t('faq_4.a_2_description'), note: t('faq_4.a_2_note') } },
        { q: t('faq_4.q_3'), a: { title: t('faq_4.a_3_title'), description: t('faq_4.a_3_description'), note: t('faq_4.a_3_note') } },
        { q: t('faq_4.q_4'), a: { title: t('faq_4.a_4_title'), description: t('faq_4.a_4_description'), note: t('faq_4.a_4_note') } },
    ];

    const ACCENT = '#F15859';

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            {/* Header */}
            <Box sx={{ backgroundColor: '#132c4b', color: 'white', py: { xs: 8, md: 8 }, mb: { xs: 8, md: 10 } }}>
                <Container maxWidth="lg">
                    <Chip
                        label={t('welcome_Section.chip')}
                        sx={{
                            bgcolor: ACCENT,
                            color: "white",
                            fontWeight: 700,
                            mb: 3,
                        }}
                    />
                    <Typography
                        component="h1"
                        sx={{
                            fontSize: { xs: "24px", md: "36px" },
                            fontWeight: 800,
                            lineHeight: 1.1,
                            mb: 2,
                        }}
                    >
                        {t('welcome_Section.title')}
                    </Typography>
                    <Typography
                        sx={{
                            color: "rgba(255,255,255)",
                            mb: 2,
                            maxWidth: "80%",
                            fontSize: "14px",
                        }}
                    >
                        {descriptionLines.map((line, index) => (
                            <React.Fragment key={index}>
                                {t(`welcome_Section.description.${line}`)}
                                <br />
                            </React.Fragment>
                        ))}
                    </Typography>
                </Container>
            </Box>

            {/* FAQ Sections */}
            <Container maxWidth="lg">
                <Box>
                    <FaqSection
                        categoryTitle={t('faq_1.title')}
                        items={preparationItems}
                        keyWord={t('key_word')}
                    />
                </Box>
                <Box>
                    <FaqSection
                        categoryTitle={t('faq_2.title')}
                        items={serviceItems}
                        keyWord={t('key_word')}
                    />
                </Box>
                <Box>
                    <FaqSection
                        categoryTitle={t('faq_3.title')}
                        items={supportItems}
                        keyWord={t('key_word')}
                    />
                </Box>
                <Box>
                    <FaqSection
                        categoryTitle={t('faq_4.title')}
                        items={feeContract}
                        keyWord={t('key_word')}
                    />
                </Box>
            </Container>

            <FooterFaq />

            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "@id": "https://airxpress.jp/faq#faq",
                        "url": "https://airxpress.jp/faq",
                        "inLanguage": "ja",
                        "isPartOf": {
                            "@type": "WebSite",
                            "name": "AirXpress",
                            "url": "https://airxpress.jp"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "AirXpress",
                            "url": "https://airxpress.jp"
                        },
                        "mainEntity": [
                            ...preparationItems,
                            ...serviceItems,
                            ...supportItems,
                            ...feeContract,
                        ].map(item => ({
                            "@type": "Question",
                            "@id": `https://airxpress.jp/faq#${encodeURIComponent(item.q)}`,
                            "name": item.q,
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": [item.a.title, item.a.description, item.a.note].filter(Boolean).join(' ').replace(/<[^>]+>/g, "")
                            }
                        }))
                    })
                }}
            />
        </Box>
    );
}
